import React from "react"
import { getFormattedTime } from "utils"

const getReplyForQuestion = (replies, question) => {
  let reply = null

  replies.forEach(replyX => {
    if (replyX.question_id == question.id) {
      if (!reply) {
        reply = replyX.answer.answer
      } else {
        reply += ", " + replyX.answer.answer
      }
    }
  })

  return reply
}

const viewResultsListColumns = questions => {
  let columns = [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item.id}</>,
    },
    {
      text: "Submission Date",
      dataField: "created_at",
      formatter: (cellContent, item) => (
        <>{getFormattedTime(item?.created_at?.date)}</>
      ),
    },
    {
      text: "Name",
      dataField: "user.firs_name",
      formatter: (cellContent, item) => <>{item?.user?.first_name}</>,
    },
    {
      text: "Email",
      dataField: "user.email",
      formatter: (cellContent, item) => <>{item?.user?.email}</>,
    },
    {
      text: "Result",
      dataField: "score_title",
      formatter: (cellContent, item) => <>{item?.score_title}</>,
    },
  ]

  questions?.forEach(q => {
    columns?.push({
      text: q?.question,
      dataField: "replies",
      formatter: (cellContent, item) => (
        <>{getReplyForQuestion(item?.replies, q)}</>
      ),
    })
  })

  return columns
}

export default viewResultsListColumns
